import React, { useRef } from "react";
import Viewer from "viewerjs/dist/viewer.js";
import "./image-viewer.scss";

export const ImageViewer = ({ url, photographyWipKey }) => {
    const viewer = useRef(null);

    const onLoad = () => {
        if (viewer.current) {
            viewer.current.destroy();
        }

        viewer.current = new Viewer(document.getElementById(`img_${photographyWipKey}`), {
            backdrop: false,
            inline: true,
            navbar: false,
            button: false,
            title: false,
            toolbar: {
                zoomIn: 1,
                zoomOut: 1,
                oneToOne: false,
                reset: 1,
                prev: 0,
                play: false,
                next: 0,
                rotateLeft: 1,
                rotateRight: 1,
                flipHorizontal: 1,
                flipVertical: 1,
            },
        });
    };

    return (
        <div
            id={`img_${photographyWipKey}`}
            className="image-viewer"
            onLoad={onLoad}
        >
            <img
                className="image-viewer-placeholder"
                alt={photographyWipKey}
                src={url}
            />
        </div>
    );
};
